import { Button, Center } from "@chakra-ui/react";
import React, { ReactNode, useState } from "react";
import { FormattedMessage } from "react-intl";

import { RanaModal } from "@nens/ranalib";

import ColorWheel from "./ColorWheel";

interface Props {
  initialColor: string;
  onColorSave: (color: string) => void;
  closeModal: () => void;
  header: string | ReactNode | JSX.Element;
}

const ColorPicker: React.FC<Props> = (props) => {
  const [selectedColor, setSelectedColor] = useState(props.initialColor);
  const onModalSave = () => {
    props.onColorSave(selectedColor);
    props.closeModal();
  };
  return (
    <RanaModal
      isOpen={true}
      onClose={props.closeModal}
      buttons={[
        <Button variant="primary" onClick={onModalSave}>
          <FormattedMessage id="model.save_button" defaultMessage="Save" />
        </Button>,
      ]}
      topBar={props.header}
    >
      <Center>
        <ColorWheel initialColor={props.initialColor} onColorChange={setSelectedColor} />
      </Center>
    </RanaModal>
  );
};

export default ColorPicker;
